import { RegisterEmailTranslations } from "#i18n/translations/pt-BR/recovery/register-email";

export const REGISTER_EMAIL_FR_FR: RegisterEmailTranslations = {
	registerEmail: "Enregistrez un e-mail pour continuer",
	cardInfo: `Nous vous enverrons un lien pour authentifier cet e-mail et, après cela, vous pourrez accéder 
	normalement avec votre identifiant et mot de passe.`,
	description: "C'est rapide et sera fait une seule fois.",
	enterprise: "Entreprise",
	email: "E-mail",
	emailPlaceholder: "Entrez votre e-mail",
	enterprisePlaceholder: "Entrez votre entreprise",
	login: "Identifiant",
	password: "Mot de passe",
	confirmPassword: "Confirmer le mot de passe",
	confirm: "Confirmer et envoyer l'e-mail",
	send: "Envoyer",
	backToLogin: "Retour au Login",
	sendEmailModal: {
		title: "L'e-mail a été envoyé!",
		subtitle1: "Nous avons envoyé un lien à {{email}}",
		subtitle2:
			"Ouvrez l'e-mail et cliquez sur 'Authentifier l'e-mail' pour continuer à accéder au tableau de bord.",
	},
	emailConfirmedModal: {
		title: "L'e-mail que vous avez enregistré a été authentifié!",
		subtitle:
			"Vous pouvez maintenant accéder au Dashboard Zig avec votre identifiant et mot de passe normalement.",
		makeLogin: "Faire login",
	},
	expiredLinkModal: {
		title: "Ce lien a expiré!",
		subtitle:
			"Entrez l'e-mail à nouveau pour que un nouveau lien d'authentification soit envoyé.",
		registerEmail: "Enregistrer l'e-mail",
	},
	resendEmail: "Renvoyer l'e-mail dans ({{countDown}})",
	fields: {
		enterprise: {
			required: "Le nom de l'entreprise est requis",
		},
		email: {
			required: "L'e-mail est requis",
			invalid: "Entrez un e-mail valide",
		},
	},
};
